module.exports = __webpack_public_path__ + "img/2.92d93c24.png";